export enum MOBILE_FORM_DIALOG_TOGGLE_ORIGIN {
  BUTTON = 'button',
  SWITCH = 'switch',
}
